import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import { toast } from "react-toastify";
import { isEmpty, pick } from "lodash";

import AuthContext from "../context/AuthContext";
import { apiPost } from "../Utils/apiFetch";
import { apiPath } from "../Utils/apiPath";
import { Helmet } from "react-helmet-async";
import { Form } from "react-bootstrap";
import faeye from "../fa-eye.svg";
import faeyeslash from "../fa-eye-slash.svg";
import { showAlert } from "../Utils/Constant";
// simple RFC4122-ish uuid, matching the shape of the static defaultValue
// seen in the real markup (e.g. "ffc14e4b-fc0b-4ad8-9449-be2ff4d59a78")
const generateUuid = () =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

const MobileLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [uniqueId] = useState(generateUuid);
  const [getValidateCode, setValidateCode] = useState("");
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const setUser = useContextSelector(AuthContext, (ctx) => ctx.setUser);
  const setUserCoins = useContextSelector(
    AuthContext,
    (ctx) => ctx.setUserCoins,
  );
  const canvasRef = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });

  // const changeCode = () => {
  //   const canvas = canvasRef.current;
  //   const context = canvas.getContext("2d");
  //   context.font = "bold 70px sans-serif";
  //   const code = Math.floor(1000 + Math.random() * 9000);
  //   context.clearRect(0, 0, canvas.width, canvas.height);
  //   context.fillText(code, 10, 50);
  //   setValidateCode(code);
  // };

  // useEffect(() => {
  //   changeCode();
  // }, []);
  const [isLoged, setIsLoged] = useState("");

  const onSubmit = async (body) => {
    setLoading(true);
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    body.website = hostname || "SABAEXCH";

    const { status, data } = await apiPost(
      apiPath.loginUser,
      pick(body, ["username", "password", "uniqueId", "website"]),
    );

    if (status === 200 && data.success) {
      localStorage.setItem("token", data.results.token);
      localStorage.setItem("refresh_token", data.results.refresh_token);

      // save the message so it survives the reload
      sessionStorage.setItem("loginSuccessMsg", "Logged In Successfully");

      setUserCoins({
        exposure: data.results.exposure,
        totalCoins: data.results.totalCoins,
      });
      setUser(jwtDecode(data.results.token));
      setIsLoged("loged");

      window.location.href = "/"; // keep this last
    } else {
      setIsLoged("failed");
      // toast.error(data?.message);
    }
    setLoading(false);
  };
  const [passwordType, setPasswordType] = useState("password");
  const togglePassword = (e) => {
    e.preventDefault();
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  return (
    <app-login _nghost-serverapp-c76>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <app-login-mob _ngcontent-serverapp-c76 _nghost-serverapp-c74>
        <div
          apptheme
          className="over-wrap loading-overlay"
          style={{ display: loading ? "block" : "none" }}
        >
          <div
            id="loading"
            className="loading-wrap"
            style={{ display: "block" }}
          >
            <ul className="loading">
              <li>
                <img
                  src="/assets/images/loading40.gif"
                  className="loaderclass"
                />
              </li>
              <li style={{ padding: "10px" }}>Loading...</li>
              <br />
              <li>
                <span id="progress" />
              </li>
            </ul>
          </div>
        </div>

        <div className="mobile-view">
          <div apptheme className="ui-mobile-viewport ui-overlay-a">
            <div
              data-role="page"
              data-url="/login/agent/login.jsp"
              tabIndex={0}
              className="ui-page ui-page-theme-a ui-page-active backhround"
            >
              <header style={{ display: "block" }} className="login-head">
                <h1>SKYEXCHANGE</h1>
              </header>
              <div className="apk-btn">
                <form noValidate onSubmit={handleSubmit(onSubmit)}>
                  <dl className="form-login">
                    <dd id="loginNameErrorClass">
                      <input
                        autoComplete="on"
                        id="loginName"
                        type="text"
                        appinputrestriction="noSpecialChars"
                        placeholder="Username"
                        {...register("username", {
                          required: "Please enter Username",
                        })}
                      />
                      {errors.username && (
                        <span className="error-text">
                          {errors.username.message}
                        </span>
                      )}
                    </dd>
                    <dd id="passwordErrorClass">
                      <div style={{ position: "relative" }}>
                        <input
                          id="password"
                          autoComplete="on"
                          placeholder="Password"
                          type={passwordType ? passwordType : "password"}
                          {...register("password", {
                            required: "Please enter password",
                          })}
                        />
                        <div
                          className="input-group-btn"
                          style={{
                            position: "absolute",
                            right: "0",
                            top: "0",
                            bottom: "0px",
                          }}
                        >
                          <span
                            className="btn btn-outline-primary"
                            onClick={togglePassword}
                            style={{
                              backgroundColor: "transparent",
                              backgroundImage: `none`,
                              border: "0",
                              padding: "8px 6px",
                              paddingTop: "3px",
                              height: "72%",
                              fontSize: `6.5vw`,
                              lineHeight: `1.2`,
                            }}
                          >
                            {passwordType === "password" ? (
                              <img src={faeyeslash} style={{ width: `20px` }} />
                            ) : (
                              <img src={faeye} style={{ width: `20px` }} />
                            )}
                          </span>
                        </div>
                      </div>
                      {errors.password && (
                        <span className="error-text">
                          {errors.password.message}
                        </span>
                      )}
                    </dd>
                    {/* <dd>
                      <Form.Control
                        type="text"
                        placeholder="Validate Code"
                        maxLength="4"
                        className={errors.validateCode ? "is-invalid" : ""}
                        {...register("validateCode", {
                          required: "Please enter validate code",
                          validate: {
                            validate: (value) =>
                              parseInt(value) === parseInt(getValidateCode) ||
                              "Invalid validate code",
                          },
                        })}
                      />
                      <canvas
                        style={{
                          position: "absolute",
                          right: "-10%",
                          top: "28%",
                        }}
                        className="canvas-img "
                        ref={canvasRef}
                        onClick={changeCode}
                      />
                      {errors.validateCode && errors.validateCode.message && (
                        <label className="invalid-feedback text-left">
                          {errors.validateCode.message}
                        </label>
                      )}
                    </dd> */}
                    <dd>
                      <button
                        type="submit"
                        className="btn-send ui-link"
                        style={{ width: "100%" }}
                        disabled={loading}
                      >
                        {loading ? "Logging in..." : "Login"}
                      </button>
                    </dd>
                    <dd id="errorMsg" className="state" />
                    {isLoged == "failed" && (
                      <dd
                        id="errorMsg"
                        class="state text-red"
                        style={{ color: "red" }}
                      >
                        Invalid Username/password
                      </dd>
                    )}
                  </dl>
                </form>
                <div className="V-spacer" style={{ marginTop: "4rem" }} />
                <a id="apk" href="#" download="#">
                  <img
                    style={{ width: "9rem" }}
                    src={"/assets/images/android.png"}
                    width="auto"
                  />
                </a>
              </div>

              <div id="supportWrap" className="support-wrap">
                <div className="support-service">
                  <a
                    id="support_whatsapp"
                    className="support-whatsapp ui-link open"
                  >
                    <img
                      src="/assets/images/transparent.gif"
                      title="WhatsApp"
                    />
                  </a>
                  <a id="support_email" className="support-mail ui-link">
                    <img src="/assets/images/transparent.gif" title="Email" />
                  </a>
                  <a id="support_telegram" className="support-telegram ui-link">
                    <img
                      src="/assets/images/transparent.gif"
                      title="Telegram"
                    />
                  </a>
                  <a id="support_skype" className="support-skype ui-link">
                    <img src="/assets/images/transparent.gif" title="Skype" />
                  </a>
                  <a id="support_instagram" className="support-ig ui-link">
                    <img
                      src="/assets/images/transparent.gif"
                      title="Instagram"
                    />
                  </a>
                  <a id="support-facebook" className="support-fb">
                    <img
                      src="/assets/images/transparent.gif"
                      title="facebook"
                    />
                  </a>
                  <a id="support-web" className="ouragent">
                    <img src="/assets/images/transparent.gif" title="website" />
                  </a>
                </div>
                <div className="support-info">
                  <div id="supportDetail_whatsapp" className="support-detail">
                    <a className="ui-link" href="https://wa.me/">
                      <span />
                    </a>
                    <a className="ui-link" href="https://wa.me/">
                      <span />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-login-mob>
    </app-login>
  );
};

export default MobileLogin;
